"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[157],{

/***/ 70157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ checkout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__(18499);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/toggled/dist/toggled.esm.js
var toggled_esm = __webpack_require__(67866);
// EXTERNAL MODULE: ./src/components/form-scroll-to-error/index.ts + 1 modules
var form_scroll_to_error = __webpack_require__(5115);
// EXTERNAL MODULE: ./src/components/shipping-modal/index.tsx + 11 modules
var shipping_modal = __webpack_require__(65519);
// EXTERNAL MODULE: ./src/contexts.ts
var contexts = __webpack_require__(74638);
// EXTERNAL MODULE: ./src/gql/queries/index.ts + 45 modules
var queries = __webpack_require__(98);
// EXTERNAL MODULE: ./src/hooks/use-buying-in-store.ts
var use_buying_in_store = __webpack_require__(54256);
// EXTERNAL MODULE: ./src/hooks/use-express-delivery-session.ts
var use_express_delivery_session = __webpack_require__(57999);
// EXTERNAL MODULE: ./src/hooks/use-modal-manager.ts
var use_modal_manager = __webpack_require__(63637);
// EXTERNAL MODULE: ./src/hooks/use-multi-distributor-session.ts
var use_multi_distributor_session = __webpack_require__(15382);
// EXTERNAL MODULE: ./src/truck/notifier/index.tsx + 2 modules
var notifier = __webpack_require__(5002);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/components/index.ts + 138 modules
var components = __webpack_require__(36357);
// EXTERNAL MODULE: ./src/components/action/index.ts
var action = __webpack_require__(11749);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./src/gql/mutations/index.ts + 42 modules
var mutations = __webpack_require__(36651);
// EXTERNAL MODULE: ./src/truck/icon-button/index.tsx + 2 modules
var icon_button = __webpack_require__(88497);
// EXTERNAL MODULE: ./src/truck/label/index.tsx
var label = __webpack_require__(67734);
// EXTERNAL MODULE: ./src/utils/index.ts + 24 modules
var utils = __webpack_require__(90644);
;// CONCATENATED MODULE: ./src/components/coupon-card/CouponCard.style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-bottom: ",
        "px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        "px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  height: ",
        "px;\n  padding: ",
        "px ",
        "px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: ",
        "px;\n  overflow: auto;\n  padding: ",
        "px 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  height: ",
        "px;\n  justify-content: space-between;\n  padding: ",
        "px ",
        "px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var StyledCouponCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-de631928-0"
})(_templateObject1(), function(props) {
    return props.theme.colors.white;
}, function(props) {
    return props.theme.spacing.compact;
}, function(props) {
    return props.$hasScroll && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), function(props) {
        return props.theme.spacing.comfortable;
    });
});
var StyledAddCouponContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-de631928-1"
})(_templateObject2(), function(props) {
    return props.theme.spacing.cozy * 7;
}, function(props) {
    return props.theme.spacing.cozy;
}, function(props) {
    return props.theme.spacing.comfortable;
});
var StyledCouponList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-de631928-2"
})(_templateObject3(), function(props) {
    return props.theme.spacing.relaxed * 6;
}, function(props) {
    return props.theme.spacing.compact;
});
var StyledCoupon = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-de631928-3"
})(_templateObject4(), function(props) {
    return props.theme.spacing.cozy * 7;
}, function(props) {
    return props.theme.spacing.cozy;
}, function(props) {
    return props.theme.spacing.comfortable;
});

;// CONCATENATED MODULE: ./src/components/coupon-card/CouponCard.tsx

















function CouponCard(props) {
    var couponsList = props.couponsList, onOpen = props.onOpen, orderId = props.orderId, style = props.style;
    var ref = (0,_sliced_to_array/* default */.Z)((0,react_hooks_esm/* useMutation */.Db)(mutations/* removeCouponMutation */.Cw), 1), removeCoupon = ref[0];
    var flagQueryFn = (0,toggled_esm/* useFlagQueryFn */.rt)();
    var canSelectTimeRange = flagQueryFn(constants/* flagQueries.CAN_SELECT_TIME_RANGE */.mE.CAN_SELECT_TIME_RANGE);
    var withPurchaseOrderStep = flagQueryFn(constants/* flags.UPLOAD_PURCHASE_ORDER */.id.UPLOAD_PURCHASE_ORDER);
    var onDelete = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(couponId) {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            removeCoupon({
                                variables: {
                                    couponId: couponId
                                },
                                refetchQueries: [
                                    {
                                        query: queries/* orderCouponsQuery */.mn,
                                        variables: {
                                            orderId: orderId
                                        }
                                    },
                                    {
                                        query: queries/* checkoutQuery */.ub,
                                        variables: {
                                            canSelectTimeRange: canSelectTimeRange,
                                            withPurchaseOrderStep: withPurchaseOrderStep
                                        }
                                    }
                                ]
                            })
                        ];
                    case 1:
                        _state.sent();
                        notifier/* default.success */.Z.success("El cup\xf3n ha sido eliminado");
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        (0,utils/* handleSubmissionErrors */.ou)(error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function onDelete(couponId) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCouponCard, {
        $hasScroll: (couponsList === null || couponsList === void 0 ? void 0 : couponsList.length) > 2,
        style: style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAddCouponContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                        as: "span",
                        $textStyle: "h5Semibold",
                        children: "Cup\xf3n"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(action/* default */.Z, {
                        $color: "info",
                        onClick: function() {
                            onOpen(true);
                        },
                        style: {
                            marginLeft: "auto"
                        },
                        children: "Agregar"
                    })
                ]
            }),
            !(0,lodash.isEmpty)(couponsList) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCouponList, {
                children: couponsList.map(function(coupon, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCoupon, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                                as: "span",
                                $textStyle: "h5Regular",
                                $color: "grayscale60",
                                $ellipsis: true,
                                children: coupon.code
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_button/* IconButton */.h, {
                                size: "md",
                                color: "error",
                                type: "trash",
                                onClick: function() {
                                    return onDelete(coupon.id);
                                }
                            })
                        ]
                    }, idx);
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/coupon-card/index.ts


// EXTERNAL MODULE: ./src/components/coupon-modal/CouponModal.tsx + 1 modules
var CouponModal = __webpack_require__(34691);
// EXTERNAL MODULE: ./src/hooks/index.ts + 31 modules
var hooks = __webpack_require__(81251);
// EXTERNAL MODULE: ./src/hooks/use-checkout-tabs.tsx
var use_checkout_tabs = __webpack_require__(16949);
// EXTERNAL MODULE: ./src/hooks/use-pricing.tsx
var use_pricing = __webpack_require__(34390);
// EXTERNAL MODULE: ./src/components/price/index.tsx + 5 modules
var price = __webpack_require__(50070);
// EXTERNAL MODULE: ./src/components/pricing/price-line.tsx
var price_line = __webpack_require__(42477);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
;// CONCATENATED MODULE: ./src/modules/checkout/components/cart-pricing/CartPricing.style.tsx

function CartPricing_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        "px;\n  display: ",
        ";\n\n  ",
        " {\n    display: block;\n  }\n"
    ]);
    CartPricing_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CartPricing_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: ",
        "px;\n  padding-bottom: 0;\n  width: 100%;\n"
    ]);
    CartPricing_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CartPricing_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: ",
        "px;\n"
    ]);
    CartPricing_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CartPricing_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  width: ",
        "px;\n"
    ]);
    CartPricing_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CartPricing_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: ",
        "px;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n  padding: ",
        "px;\n"
    ]);
    CartPricing_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  height: 1px;\n  margin-bottom: ",
        "px;\n  margin-top: ",
        "px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var CartPricingContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98a53bf4-0"
})(CartPricing_style_templateObject(), function(props) {
    return props.theme.colors.white;
}, function(props) {
    return props.theme.spacing.compact;
}, function(props) {
    return props.$showCartPricing ? "block" : "none";
}, (0,styled_breakpoints.up)("lg"));
var TitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98a53bf4-1"
})(CartPricing_style_templateObject1(), function(props) {
    return props.theme.spacing.comfortable;
});
var LabelsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98a53bf4-2"
})(CartPricing_style_templateObject2(), function(props) {
    return props.theme.spacing.compact;
});
var IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98a53bf4-3"
})(CartPricing_style_templateObject3(), function(props) {
    return props.theme.spacing.relaxed;
});
var PriceLineList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98a53bf4-4"
})(CartPricing_style_templateObject4(), function(props) {
    return props.theme.spacing.compact;
}, function(props) {
    return props.theme.spacing.cozy;
}, function(props) {
    return props.theme.spacing.comfortable;
});
var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98a53bf4-5"
})(_templateObject5());
var StyledSeparator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98a53bf4-6"
})(_templateObject6(), function(props) {
    return props.theme.colors.gray;
}, function(props) {
    return props.theme.spacing.cozy;
}, function(props) {
    return props.theme.spacing.cozy;
});

;// CONCATENATED MODULE: ./src/modules/checkout/components/cart-pricing/CartPricing.tsx









function CartPricing(props) {
    var lines = props.lines;
    var hasAttachPaymentSummaryFF = (0,toggled_esm/* useFlag */.P5)(constants/* flags.DEV_ATTACH_PAYMENT_SUMMARY */.id.DEV_ATTACH_PAYMENT_SUMMARY);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartPricingContainer, {
        $showCartPricing: !hasAttachPaymentSummaryFF,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelsContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: "font-semibold",
                        children: "Precio detallado"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceLineList, {
                children: (0,lodash.map)(lines, function(line, index) {
                    var ref, ref1, ref2;
                    if (line.type === price_line/* PriceLineType.LABEL */.$.LABEL) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs text-secondary",
                                children: line.label
                            })
                        }, "price-line-".concat(index));
                    }
                    if (line.type === price_line/* PriceLineType.SEPARATOR */.$.SEPARATOR) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSeparator, {}, "price-line-".concat(index));
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                                as: "span",
                                $textStyle: (ref = line.lineStyle) === null || ref === void 0 ? void 0 : ref.textStyle,
                                children: line.label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(price/* default */.Z, {
                                className: "shrink-0",
                                value: line === null || line === void 0 ? void 0 : line.price,
                                textStyle: line === null || line === void 0 ? void 0 : (ref1 = line.lineStyle) === null || ref1 === void 0 ? void 0 : ref1.textStyle,
                                color: line === null || line === void 0 ? void 0 : (ref2 = line.lineStyle) === null || ref2 === void 0 ? void 0 : ref2.priceColor
                            })
                        ]
                    }, "price-line-".concat(index));
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/truck/icon/index.tsx + 1 modules
var icon = __webpack_require__(63216);
// EXTERNAL MODULE: ./src/truck/image/index.tsx
var truck_image = __webpack_require__(52679);
// EXTERNAL MODULE: ./src/truck/theme.ts
var theme = __webpack_require__(78904);
;// CONCATENATED MODULE: ./src/modules/checkout/components/line-items-summary/LineitemsSummary.style.tsx

function LineitemsSummary_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        "px;\n"
    ]);
    LineitemsSummary_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LineitemsSummary_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  display: flex;\n  padding: ",
        "px;\n  padding-bottom: ",
        "px;\n  width: 100%;\n"
    ]);
    LineitemsSummary_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LineitemsSummary_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  border-bottom: 1px solid ",
        ";\n  display: flex;\n  gap: ",
        "px;\n  justify-content: flex-start;\n  padding: ",
        "px 0;\n"
    ]);
    LineitemsSummary_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function LineitemsSummary_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  margin-bottom: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 0 ",
        "px;\n  position: relative;\n\n  ",
        " {\n    max-height: ",
        "px;\n  }\n\n  > :last-child {\n    border-bottom: 0;\n  }\n"
    ]);
    LineitemsSummary_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function LineitemsSummary_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: flex-end;\n  display: flex;\n  flex-direction: column;\n  height: ",
        "px;\n  justify-content: flex-end;\n  position: relative;\n  width: ",
        "px;\n"
    ]);
    LineitemsSummary_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function LineitemsSummary_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  border-radius: 1rem;\n  display: flex;\n  font-size: ",
        "px;\n  font-weight: 600;\n  height: 1.5rem;\n  justify-content: center;\n  padding: 0 0.5rem;\n  width: fit-content;\n"
    ]);
    LineitemsSummary_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function LineitemsSummary_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-start;\n  width: 100%;\n"
    ]);
    LineitemsSummary_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: ",
        "px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  width: ",
        "px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var LineItemsSummaryContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5335fc37-0"
})(LineitemsSummary_style_templateObject(), function(props) {
    return props.theme.colors.white;
}, function(props) {
    return props.theme.spacing.compact;
});
var LineitemsSummary_style_TitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5335fc37-1"
})(LineitemsSummary_style_templateObject1(), function(props) {
    return props.theme.spacing.comfortable;
}, function(props) {
    return props.$isOpen ? 0 : props.theme.spacing.comfortable;
});
var LineItemSummaryContainer = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-5335fc37-2"
})(LineitemsSummary_style_templateObject2(), function(props) {
    return props.theme.palette.grayscale40;
}, function(props) {
    return props.theme.spacing.cozy;
}, function(props) {
    return props.theme.spacing.cozy;
});
var LineItemsList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-5335fc37-3"
})(LineitemsSummary_style_templateObject3(), function(props) {
    return props.$isOpen ? "block" : "none";
}, function(props) {
    return props.theme.spacing.comfortable;
}, (0,styled_breakpoints.up)("lg"), function(props) {
    return props.theme.spacing.cozy * 25;
});
var LineItemImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5335fc37-4"
})(LineitemsSummary_style_templateObject4(), function(props) {
    return props.theme.spacing.cozy * 9;
}, function(props) {
    return props.theme.spacing.cozy * 12;
});
var LineItemQuantityCircle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5335fc37-5"
})(LineitemsSummary_style_templateObject5(), function(props) {
    return props.theme.colors.gray;
}, function(props) {
    return props.theme.spacing.compact * 3;
});
var ImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5335fc37-6"
})(LineitemsSummary_style_templateObject6());
var LineitemsSummary_style_LabelsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5335fc37-7"
})(_templateObject7(), function(props) {
    return props.theme.spacing.compact;
});
var LineitemsSummary_style_IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5335fc37-8"
})(_templateObject8(), function(props) {
    return props.theme.spacing.relaxed;
});

;// CONCATENATED MODULE: ./src/modules/checkout/components/line-items-summary/LineItemsSummary.tsx











function LineItem(param) {
    var name = param.name, sku = param.sku, quantity = param.quantity, total = param.total, photo = param.photo, presentation = param.presentation, attributesSummary = param.attributesSummary;
    var currencyConfig = (0,hooks/* useCurrencyConfig */.Bp)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,utils/* formatPrice */.T4)(total, currencyConfig), 2), valueInt = ref[0], valueDecimal = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineItemSummaryContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineItemImageContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LineItemQuantityCircle, {
                        children: quantity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_image/* default */.Z, {
                            src: photo,
                            height: theme/* default.spacing.compact */.Z.spacing.compact * 13,
                            width: theme/* default.spacing.compact */.Z.spacing.compact * 13
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-xs",
                                children: name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-xs text-tertiary",
                                children: [
                                    "sku: ",
                                    sku
                                ]
                            }),
                            presentation && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-xs text-tertiary",
                                children: presentation
                            }),
                            attributesSummary && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-xs text-tertiary",
                                children: attributesSummary
                            })
                        ]
                    }),
                    total && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-secondary",
                        children: [
                            valueInt,
                            valueDecimal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    currencyConfig.decimal,
                                    valueDecimal
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function LineItemsSummary(props) {
    var lineItems = props.lineItems;
    var ref = (0,react.useState)(null), isOpen = ref[0], setIsOpen = ref[1];
    var subtitle = "".concat(lineItems.length, " ").concat(lineItems.length > 1 ? "productos" : "producto");
    var hidePricing = (0,toggled_esm/* useFlag */.P5)(constants/* flags.HIDE_PRICES */.id.HIDE_PRICES);
    var isMobile = (0,hooks/* useIsMobile */.dD)();
    (0,react.useEffect)(function() {
        if (isMobile) {
            setIsOpen(true);
        }
    }, [
        isMobile
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineItemsSummaryContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineitemsSummary_style_TitleContainer, {
                $isOpen: isOpen,
                onClick: function() {
                    return setIsOpen(!isOpen);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineitemsSummary_style_LabelsContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "font-semibold",
                                children: "Resumen de compra"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-xs text-secondary",
                                children: subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LineitemsSummary_style_IconContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                            type: isOpen ? "caret-up" : "caret-down",
                            size: "sm",
                            color: "grayscale80"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LineItemsList, {
                $isOpen: isOpen,
                children: lineItems.map(function(lineItem, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LineItem, {
                        name: lineItem.name,
                        sku: lineItem.sku,
                        quantity: lineItem.quantity,
                        total: !hidePricing ? lineItem.price * lineItem.quantity : null,
                        photo: utils/* cloudinary.applyTransformations */.nl.applyTransformations(lineItem.photo, constants/* transformations.TINY_PRODUCT */.S7.TINY_PRODUCT),
                        presentation: lineItem.presentation,
                        attributesSummary: lineItem.product.attributesSummary
                    }, idx);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/truck/anchor/index.ts
var truck_anchor = __webpack_require__(75689);
// EXTERNAL MODULE: ./src/truck/card/index.tsx
var card = __webpack_require__(98619);
// EXTERNAL MODULE: ./src/truck/field/index.tsx + 2 modules
var field = __webpack_require__(49318);
// EXTERNAL MODULE: ./src/truck/hooks/index.ts + 1 modules
var truck_hooks = __webpack_require__(6361);
// EXTERNAL MODULE: ./src/truck/overlay/index.tsx + 1 modules
var overlay = __webpack_require__(2969);
// EXTERNAL MODULE: ./src/hooks/use-vendor.ts
var use_vendor = __webpack_require__(1360);
// EXTERNAL MODULE: ./src/variables.js
var variables = __webpack_require__(93063);
;// CONCATENATED MODULE: ./src/layouts/checkout/header/elements.js

function elements_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  display: flex;\n  height: ",
        "px;\n  justify-content: center;\n  left: 0;\n  padding: 0 ",
        "px;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: ",
        ";\n"
    ]);
    elements_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function elements_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n\n  ",
        " {\n    width: ",
        "px;\n  }\n"
    ]);
    elements_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function elements_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n\n  > :first-child {\n    margin-right: ",
        "px;\n  }\n"
    ]);
    elements_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var Container = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-86af8a12-0"
})(elements_templateObject(), function(props) {
    return props.theme.colors.primary;
}, variables/* headerHeights.checkout */.eL.checkout, theme/* default.spacing.comfortable */.Z.spacing.comfortable, variables/* stack.mainHeader */.kn.mainHeader);
var InnerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-86af8a12-1"
})(elements_templateObject1(), (0,styled_breakpoints.up)("lg"), theme/* default.spacing.cozy */.Z.spacing.cozy * 128);
var SecureContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-86af8a12-2"
})(elements_templateObject2(), theme/* default.spacing.cozy */.Z.spacing.cozy);

;// CONCATENATED MODULE: ./src/layouts/checkout/header/index.tsx







var Header = function() {
    var vendor = (0,use_vendor/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Logo */.TR, {
                    onClick: function(event) {
                        event.preventDefault();
                        (0,utils/* forceReloadTo */.yQ)("/");
                    },
                    vendor: vendor,
                    size: "small"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecureContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                            type: "lock",
                            color: "white",
                            interactive: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-xs font-semibold text-white",
                            children: "Pago Seguro"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var header = (Header);

;// CONCATENATED MODULE: ./src/modules/checkout/components/cart-pricing-mobile/CartPricingMobile.style.tsx

function CartPricingMobile_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    CartPricingMobile_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CartPricingMobile_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  padding-bottom: ",
        "px;\n  width: 100%;\n"
    ]);
    CartPricingMobile_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CartPricingMobile_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  height: ",
        "px;\n  justify-content: space-between;\n  padding-bottom: ",
        "px;\n"
    ]);
    CartPricingMobile_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CartPricingMobile_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n  padding-bottom: ",
        "px;\n"
    ]);
    CartPricingMobile_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CartPricingMobile_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    CartPricingMobile_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CartPricingMobile_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: block;\n    "
    ]);
    CartPricingMobile_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function CartPricingMobile_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  display: none;\n  height: 1px;\n  margin-bottom: ",
        "px;\n  margin-top: ",
        "px;\n\n  ",
        "\n"
    ]);
    CartPricingMobile_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function CartPricingMobile_style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  height: ",
        "px;\n  padding: ",
        "px 0;\n  width: 100%;\n"
    ]);
    CartPricingMobile_style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function CartPricingMobile_style_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  width: ",
        "px;\n"
    ]);
    CartPricingMobile_style_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var CartPricingMobile_style_CartPricingContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2aa3f59-0"
})(CartPricingMobile_style_templateObject(), (0,styled_breakpoints.up)("lg"));
var DetailsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2aa3f59-1"
})(CartPricingMobile_style_templateObject1(), function(props) {
    return props.theme.colors.gray;
}, theme/* default.spacing.compact */.Z.spacing.compact);
var CartPricingMobile_style_TitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2aa3f59-2"
})(CartPricingMobile_style_templateObject2(), theme/* default.spacing.cozy */.Z.spacing.cozy * 5, theme/* default.spacing.comfortable */.Z.spacing.comfortable);
var CartPricingMobile_style_PriceLineList = (0,styled_components_browser_esm/* default */.ZP)(card/* default */.Z).withConfig({
    componentId: "sc-d2aa3f59-3"
})(CartPricingMobile_style_templateObject3(), function(props) {
    return props.theme.spacing.cozy;
}, function(props) {
    return props.theme.spacing.cozy;
});
var StyledPriceLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2aa3f59-4"
})(CartPricingMobile_style_templateObject4());
var CartPricingMobile_style_StyledSeparator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2aa3f59-5"
})(CartPricingMobile_style_templateObject6(), function(props) {
    return props.theme.colors.gray;
}, function(props) {
    return props.theme.spacing.cozy;
}, function(props) {
    return props.theme.spacing.cozy;
}, function(props) {
    return props.$showSeparator && (0,styled_components_browser_esm/* css */.iv)(CartPricingMobile_style_templateObject5());
});
var TotalContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2aa3f59-6"
})(CartPricingMobile_style_templateObject7(), theme/* default.spacing.cozy */.Z.spacing.cozy * 7, theme/* default.spacing.comfortable */.Z.spacing.comfortable);
var StyledTotalPriceLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2aa3f59-7"
})(CartPricingMobile_style_templateObject8(), function(props) {
    return props.theme.spacing.compact * 15;
});

;// CONCATENATED MODULE: ./src/modules/checkout/components/cart-pricing-mobile/CartPricingMobile.tsx








function CartPricingMobile(props) {
    var lines = props.lines, onClose = props.onClose, isOpen = props.isOpen;
    var linesWithoutTotal = (0,lodash.reject)(lines, {
        label: "Total"
    });
    var total = (0,lodash.filter)(lines, {
        label: "Total"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartPricingMobile_style_CartPricingContainer, {
        children: [
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartPricingMobile_style_TitleContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-xl font-semibold",
                                children: "Precio detallado"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                type: "close",
                                color: "currentColor",
                                size: "sm",
                                onClick: onClose
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartPricingMobile_style_PriceLineList, {
                        children: (0,lodash.map)(isOpen ? linesWithoutTotal : total, function(lineitem) {
                            var ref, ref1, ref2;
                            if (lineitem.type === price_line/* PriceLineType.LABEL */.$.LABEL) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPriceLine, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xs text-secondary",
                                        children: lineitem.label
                                    })
                                });
                            }
                            if (lineitem.type === price_line/* PriceLineType.SEPARATOR */.$.SEPARATOR) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CartPricingMobile_style_StyledSeparator, {
                                    $showSeparator: isOpen
                                });
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPriceLine, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                                        as: "span",
                                        $textStyle: (ref = lineitem.lineStyle) === null || ref === void 0 ? void 0 : ref.textStyle,
                                        children: lineitem.label
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(price/* default */.Z, {
                                        value: lineitem === null || lineitem === void 0 ? void 0 : lineitem.price,
                                        textStyle: lineitem === null || lineitem === void 0 ? void 0 : (ref1 = lineitem.lineStyle) === null || ref1 === void 0 ? void 0 : ref1.textStyle,
                                        color: lineitem === null || lineitem === void 0 ? void 0 : (ref2 = lineitem.lineStyle) === null || ref2 === void 0 ? void 0 : ref2.priceColor
                                    })
                                ]
                            });
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalContainer, {
                onClick: onClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPriceLine, {
                    onClick: onClose,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTotalPriceLine, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-semibold",
                                    children: "Total"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                    type: props.isOpen ? "caret-down" : "caret-up",
                                    color: "black",
                                    size: "sm"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(price/* default */.Z, {
                            value: total[0].price,
                            $textStyle: "h5Semibold",
                            color: "black"
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/truck/button/index.tsx + 2 modules
var truck_button = __webpack_require__(48721);
;// CONCATENATED MODULE: ./src/layouts/checkout/navigator/elements.ts

function navigator_elements_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-top: 0;\n    "
    ]);
    navigator_elements_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function navigator_elements_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  border-top: 1px solid ",
        ";\n  bottom: 0;\n  box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n  left: 0;\n  padding: ",
        "px;\n  position: sticky;\n  z-index: ",
        ";\n\n  ",
        " {\n    background: transparent;\n    border: none;\n    bottom: unset;\n    box-shadow: unset;\n    display: flex;\n    left: unset;\n    padding: ",
        "px 0;\n    position: unset;\n    right: unset;\n  }\n\n  ",
        "\n"
    ]);
    navigator_elements_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var NavigatorContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a81225f5-0"
})(navigator_elements_templateObject1(), theme/* default.colors.white */.Z.colors.white, theme/* default.colors.gray */.Z.colors.gray, theme/* default.spacing.cozy */.Z.spacing.cozy, theme/* default.spacing.comfortable */.Z.spacing.comfortable, variables/* stack.checkoutFooter */.kn.checkoutFooter, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.comfortable */.Z.spacing.comfortable, function(props) {
    return props.$showPartialCartPricing && (0,styled_components_browser_esm/* css */.iv)(navigator_elements_templateObject());
});

;// CONCATENATED MODULE: ./src/layouts/checkout/navigator/index.tsx








var Navigator = function(props) {
    var mainButtonLabel = props.mainButtonLabel, isMainButtonDisabled = props.isMainButtonDisabled, isMainButtonLoading = props.isMainButtonLoading, onClickMainButton = props.onClickMainButton, showCartPricing = props.showCartPricing, isCartPricingOpen = props.isCartPricingOpen, onCloseCartPricing = props.onCloseCartPricing, priceLines = props.priceLines;
    var attachPaymentSummary = (0,toggled_esm/* useFlag */.P5)(constants/* flags.DEV_ATTACH_PAYMENT_SUMMARY */.id.DEV_ATTACH_PAYMENT_SUMMARY);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavigatorContainer, {
        $showPartialCartPricing: !isCartPricingOpen && attachPaymentSummary,
        children: [
            showCartPricing && priceLines && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartPricingMobile, {
                lines: priceLines,
                onClose: onCloseCartPricing,
                isOpen: isCartPricingOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_button/* default */.Z, {
                color: "secondary",
                disabled: isMainButtonDisabled,
                onClick: onClickMainButton,
                loading: isMainButtonLoading,
                children: mainButtonLabel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_anchor/* default */.Z, {
                href: "/",
                $color: "info",
                $textStyle: "h5Semibold",
                children: "Seguir comprando"
            })
        ]
    });
};
/* harmony default export */ var checkout_navigator = (Navigator);

// EXTERNAL MODULE: ./src/truck/utils/index.ts + 8 modules
var truck_utils = __webpack_require__(14250);
;// CONCATENATED MODULE: ./src/layouts/checkout/tabs/elements.js

function tabs_elements_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  display: flex;\n  margin-bottom: ",
        "px;\n  margin-left: ",
        "px;\n  margin-right: ",
        "px;\n  position: relative;\n\n  ",
        ";\n\n  ",
        " {\n    margin-bottom: ",
        "px;\n    margin-left: 0;\n    margin-right: 0;\n  }\n"
    ]);
    tabs_elements_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function tabs_elements_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  color: ",
        ";\n  cursor: ",
        ";\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  transition:\n    fill 0.2s ease-in,\n    color 0.2s ease-in;\n  user-select: none;\n  z-index: 1;\n\n  ",
        ";\n  ",
        ";\n\n  > svg {\n    fill: ",
        ";\n  }\n"
    ]);
    tabs_elements_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function tabs_elements_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        "px;\n  height: 100%;\n  position: absolute;\n  transition: left 0.17s ease-in-out;\n  z-index: 0;\n\n  ",
        ";\n"
    ]);
    tabs_elements_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var sharedStyle = "\n  border-radius: ".concat(theme/* default.spacing.cozy */.Z.spacing.cozy * 5, "px;\n  height: ").concat(theme/* default.spacing.cozy */.Z.spacing.cozy * 6, "px;\n");
var TabContainer = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-8a563f05-0"
})(tabs_elements_templateObject(), theme/* default.colors.white */.Z.colors.white, function(props) {
    return props.theme.colors.primary;
}, theme/* default.spacing.comfortable */.Z.spacing.comfortable, theme/* default.spacing.comfortable */.Z.spacing.comfortable, theme/* default.spacing.comfortable */.Z.spacing.comfortable, sharedStyle, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.comfortable */.Z.spacing.comfortable);
var getColor = function(props) {
    var active = props.active, providedTheme = props.theme;
    if (!active) {
        return providedTheme.colors.primary;
    }
    return providedTheme.colors.white;
};
var getCursor = function(props) {
    var interactive = props.interactive;
    if (!interactive) {
        return "auto";
    }
    return "pointer";
};
var TabItem = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-8a563f05-1"
})(tabs_elements_templateObject1(), getColor, getCursor, (0,truck_utils/* getTextStyle */.BN)("h5Regular"), sharedStyle, getColor);
var getIndicatorStyle = function(props) {
    var numOfTabs = props.numOfTabs, activeIndex = props.activeIndex;
    var tabWidth = "calc(100% / ".concat(numOfTabs, ")");
    var left = "calc(".concat(activeIndex, " * ").concat(tabWidth, ")");
    return "\n    width: ".concat(tabWidth, ";\n    left: ").concat(left, ";\n  ");
};
var Indicator = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-8a563f05-2"
})(tabs_elements_templateObject2(), function(props) {
    return props.theme.colors.primary;
}, theme/* default.spacing.cozy */.Z.spacing.cozy * 5, getIndicatorStyle);

;// CONCATENATED MODULE: ./src/layouts/checkout/tabs/index.js





var Tabs = function(props) {
    var dataSource = props.dataSource;
    var router = (0,next_router.useRouter)();
    var currentStep = router.query.stepName;
    var query = {
        step: currentStep
    };
    var activeIndex = (0,lodash.findIndex)(dataSource, query);
    var renderTab = function(tab, index) {
        var route = "/comprar/".concat(tab.step);
        var interactive = index <= activeIndex;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabItem, {
            interactive: interactive,
            active: tab.step === currentStep,
            onClick: function() {
                return interactive && router.push(route);
            },
            children: tab.label
        }, "tab-".concat(tab.step));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Indicator, {
                activeIndex: activeIndex,
                numOfTabs: dataSource.length
            }),
            (0,lodash.map)(dataSource, renderTab)
        ]
    });
};
/* harmony default export */ var checkout_tabs = (Tabs);

;// CONCATENATED MODULE: ./src/layouts/checkout/content/elements.ts

function content_elements_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 100vh;\n  padding-top: ",
        "px;\n  position: relative;\n\n  ",
        " {\n    flex-direction: row;\n    justify-content: center;\n    padding-top: 0;\n\n    & > :last-child {\n      display: none;\n    }\n  }\n"
    ]);
    content_elements_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function content_elements_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n  position: relative;\n\n  ",
        " {\n    flex-direction: row;\n    padding-top: ",
        "px;\n  }\n"
    ]);
    content_elements_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function content_elements_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: inherit;\n\n  ",
        " {\n    width: ",
        "px;\n  }\n"
    ]);
    content_elements_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function elements_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n  justify-content: flex-start;\n  padding-bottom: ",
        "px;\n\n  ",
        " {\n    padding-bottom: 0;\n  }\n"
    ]);
    elements_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function elements_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  width: inherit;\n\n  // This style was added to hide navigator component in mobile view\n  & > :last-child {\n    display: none;\n  }\n\n  ",
        " {\n    width: ",
        "px;\n\n    & > :last-child {\n      display: flex;\n    }\n  }\n"
    ]);
    elements_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function elements_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        "px;\n  padding: ",
        "px;\n"
    ]);
    elements_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function elements_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    elements_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function elements_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 0;\n      padding-top: ",
        "px;\n    "
    ]);
    elements_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function elements_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        "px;\n\n  textarea {\n    resize: none;\n  }\n\n  ",
        "\n"
    ]);
    elements_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        "px;\n  display: flex;\n  flex-direction: column;\n  padding: ",
        "px 0;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var CheckoutContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6216c690-0"
})(content_elements_templateObject(), theme/* default.spacing.comfortable */.Z.spacing.comfortable * 4, (0,styled_breakpoints.up)("lg"));
var StepContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6216c690-1"
})(content_elements_templateObject1(), theme/* default.spacing.comfortable */.Z.spacing.comfortable, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.comfortable */.Z.spacing.comfortable * 4);
var TabsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6216c690-2"
})(content_elements_templateObject2(), (0,styled_breakpoints.up)("lg"), theme/* default.spacing.cozy */.Z.spacing.cozy * 86);
var PanelContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6216c690-3"
})(elements_templateObject3(), theme/* default.spacing.comfortable */.Z.spacing.comfortable, theme/* default.spacing.comfortable */.Z.spacing.comfortable, (0,styled_breakpoints.up)("lg"));
var PricingContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6216c690-4"
})(elements_templateObject4(), (0,styled_breakpoints.up)("lg"), theme/* default.spacing.cozy */.Z.spacing.cozy * 40);
var CommentsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6216c690-5"
})(elements_templateObject5(), function(props) {
    return props.theme.colors.white;
}, function(props) {
    return props.theme.spacing.compact;
}, theme/* default.spacing.comfortable */.Z.spacing.comfortable);
var CommentsLabelContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6216c690-6"
})(elements_templateObject6());
var CommentsInputContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6216c690-7"
})(elements_templateObject8(), theme/* default.spacing.comfortable */.Z.spacing.comfortable, function(props) {
    return props.$isInsideCard && (0,styled_components_browser_esm/* css */.iv)(elements_templateObject7(), theme/* default.spacing.comfortable */.Z.spacing.comfortable);
});
var TabContent = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-6216c690-8"
})(_templateObject9(), theme/* default.colors.white */.Z.colors.white, theme/* default.dimensions.borderRadius */.Z.dimensions.borderRadius, theme/* default.spacing.comfortable */.Z.spacing.comfortable);
var TermsAndConditionsSectionContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-6216c690-9"
})(_templateObject10(), theme/* default.spacing.comfortable */.Z.spacing.comfortable);

;// CONCATENATED MODULE: ./src/layouts/checkout/content/index.js





function content_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  justify-content: center;\n"
    ]);
    content_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





























var StyledOverlay = (0,styled_components_browser_esm/* default */.ZP)(overlay/* default */.Z).withConfig({
    componentId: "sc-850b1fa-0"
})(content_templateObject());
var getChildren = function(props) {
    var children = props.children, checkoutData = props.checkoutData, formProps = props.formProps, ordersToBePaid = props.ordersToBePaid, paymentMethodCurrentData = props.paymentMethodCurrentData;
    if (!(0,lodash.isFunction)(children)) {
        return children;
    }
    return children({
        checkoutData: checkoutData,
        formProps: formProps,
        ordersToBePaid: ordersToBePaid,
        paymentMethodCurrentData: paymentMethodCurrentData
    });
};
var TermsAndConditionsSection = function(props) {
    var requireTermsAndConditions = props.requireTermsAndConditions, paymentMethodSlug = props.paymentMethodSlug, vendor = props.vendor, requirePrivacyPolicy = props.requirePrivacyPolicy, style = props.style;
    var theme = (0,truck_hooks/* useTheme */.F)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TermsAndConditionsSectionContainer, {
        style: style,
        children: [
            requireTermsAndConditions && /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                className: "p-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(field/* default */.Z, {
                    as: "checkbox",
                    name: "termsAndConditionsAccepted",
                    hasText: true,
                    style: {
                        marginBottom: requirePrivacyPolicy ? theme.spacing.comfortable : 0
                    },
                    textStyle: "h6Regular",
                    children: [
                        "He le\xeddo y acepto los ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_anchor/* default */.Z, {
                            $textStyle: "h6Regular",
                            href: "/terminos-y-condiciones/".concat(paymentMethodSlug !== null && paymentMethodSlug !== void 0 ? paymentMethodSlug : ""),
                            target: "_blank",
                            children: "T\xe9rminos y Condiciones"
                        }),
                        " de ".concat(vendor.name)
                    ]
                })
            }),
            requirePrivacyPolicy && /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                className: "p-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(field/* default */.Z, {
                    as: "checkbox",
                    name: "privacyPolicyAccepted",
                    hasText: true,
                    textStyle: "h6Regular",
                    children: [
                        "He le\xeddo y acepto la ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_anchor/* default */.Z, {
                            $textStyle: "h6Regular",
                            href: "/politica-de-privacidad",
                            target: "_blank",
                            children: "Pol\xedtica de Privacidad"
                        }),
                        " de ".concat(vendor.name)
                    ]
                })
            })
        ]
    });
};
var CheckoutContent = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var router = props.router, processing = props.processing, checkoutData = props.checkoutData, _formProps = props.formProps, onClickMainButton = _formProps.handleSubmit, submittingMainButton = _formProps.submitting, _values = _formProps.values, paymentMethodSlug = _values.paymentMethodSlug, termsAndConditionsAccepted = _values.termsAndConditionsAccepted, privacyPolicyAccepted = _values.privacyPolicyAccepted, comments = _values.comments, orderId = props.orderId;
    var vendor = (0,hooks/* useVendor */.at)();
    var privacyPolicyUrl = vendor.privacyPolicyUrl, legalTermsUrl = vendor.legalTermsUrl;
    var checkoutConfig = checkoutData.checkoutConfig, currentOrder = checkoutData.checkoutState.currentOrder;
    var blockOrderByStatus = ((ref = currentOrder.status) === null || ref === void 0 ? void 0 : ref.slug) === constants/* orderStatuses.TO_BE_PAID */.bs.TO_BE_PAID;
    var query = {
        slug: paymentMethodSlug
    };
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,react_hooks_esm/* useLazyQuery */.td)(queries/* ordersToBePaidQuery */.tZ), 2), getOrdersToBePaid = ref8[0], ordersToBePaidResponse = ref8[1];
    var ref9 = (0,react.useState)(false), isCouponModalOpen = ref9[0], setIsCouponModalOpen = ref9[1];
    var ref10 = (0,react.useState)(false), isCartPricingOpen = ref10[0], setIsCartPricingOpen = ref10[1];
    var ref11 = (0,react.useState)(false), isCommentsSectionOpen = ref11[0], setIsCommentsSectionOpen = ref11[1];
    var isMobile = (0,hooks/* useIsMobile */.dD)();
    var onCloseCartPricing = function() {
        setIsCartPricingOpen(!isCartPricingOpen);
    };
    var ref12 = (0,react_hooks_esm/* useQuery */.aM)(queries/* priceLinesQuery */.Bv, {
        fetchPolicy: "cache-only"
    }), priceLinesData = ref12.data;
    var ref13;
    var priceLines = (ref13 = priceLinesData === null || priceLinesData === void 0 ? void 0 : (ref1 = priceLinesData.user) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cart) === null || ref2 === void 0 ? void 0 : ref2.priceLines) !== null && ref13 !== void 0 ? ref13 : currentOrder.priceLines;
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useLineOfCredit */.H3)({
        orderPriceLineTotal: (0,lodash.last)(priceLines).value,
        fetchPolicy: "network-only"
    }), 2), getLineOfCredit = ref14[0], lineOfCreditData = ref14[1];
    var lines = (0,use_pricing/* usePricing */.t)({
        orderPriceLines: priceLines,
        settings: {
            showTheBestRewardDescription: true
        }
    }).lines;
    var commentsField = (0,react_final_form_es/* useField */.U$)("comments");
    var paymentMethod = (0,lodash.find)(checkoutConfig.paymentMethods, query);
    var tabs = (0,use_checkout_tabs/* default */.Z)(checkoutData);
    var isPaymentScreen = router.query.stepName === constants/* checkoutSteps.PAYMENT */.b2.PAYMENT;
    var hasOrderCommentsFF = (0,toggled_esm/* useFlag */.P5)(constants/* flags.ORDER_COMMENTS */.id.ORDER_COMMENTS);
    var ordersToBePaid = (ref3 = ordersToBePaidResponse.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.user) === null || ref4 === void 0 ? void 0 : ref4.ordersToBePaid;
    var hasOrdersToBePaid = isPaymentScreen && !(0,lodash.isEmpty)(ordersToBePaid);
    /**
   * Current payment method data.
   */ var paymentMethodCurrentData = react.useMemo(function() {
        var paymentCurrentData = (0,_define_property/* default */.Z)({}, constants/* paymentMethods.LINE_OF_CREDIT */.X_.LINE_OF_CREDIT, lineOfCreditData);
        return paymentCurrentData[paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.slug];
    }, [
        paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.slug,
        lineOfCreditData === null || lineOfCreditData === void 0 ? void 0 : lineOfCreditData.isLoading
    ]);
    /**
   * Listener of the current payment method.
   */ (0,react.useEffect)(function() {
        if (!isPaymentScreen || !paymentMethod) return;
        if (paymentMethod.slug === constants/* paymentMethods.LINE_OF_CREDIT */.X_.LINE_OF_CREDIT) {
            getLineOfCredit();
        }
        getOrdersToBePaid({
            variables: {
                paymentMethodId: paymentMethod.id
            }
        });
    }, [
        paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.slug
    ]);
    var getNavigatorLabel = function() {
        if (!isPaymentScreen) {
            return "Siguiente";
        }
        if (paymentMethod && (paymentMethod.isCard || paymentMethod.isExternal)) {
            return "Pagar y Finalizar";
        }
        return "Finalizar";
    };
    var needsToAgreeToLegalDocumentsOnCheckoutSteps = (0,toggled_esm/* useFlag */.P5)(constants/* flags.NEEDS_TO_AGREE_TO_LEGAL_DOCUMENTS_IN_CHECKOUT_STEPS */.id.NEEDS_TO_AGREE_TO_LEGAL_DOCUMENTS_IN_CHECKOUT_STEPS);
    var requireTermsAndConditions = !!legalTermsUrl && needsToAgreeToLegalDocumentsOnCheckoutSteps || isPaymentScreen && (paymentMethod === null || paymentMethod === void 0 ? void 0 : (ref5 = paymentMethod.settings) === null || ref5 === void 0 ? void 0 : ref5.requireTermsAndConditions);
    var requirePrivacyPolicy = !!privacyPolicyUrl && needsToAgreeToLegalDocumentsOnCheckoutSteps;
    var paymentMethodMinimum = (0,utils/* getPaymentMethodMinimumAmount */.Gp)(paymentMethod);
    var total = (ref6 = (0,lodash.find)(priceLines, {
        label: "Total"
    })) === null || ref6 === void 0 ? void 0 : ref6.value;
    var hasMinimumPaymentMethodValue = total >= paymentMethodMinimum;
    var ref15 = (0,react_hooks_esm/* useQuery */.aM)(queries/* orderCouponsQuery */.mn, {
        variables: {
            orderId: orderId
        }
    }), orderData = ref15.data;
    var hidePricing = (0,toggled_esm/* useFlag */.P5)(constants/* flags.HIDE_PRICES */.id.HIDE_PRICES);
    var attachPaymentSummary = (0,toggled_esm/* useFlag */.P5)(constants/* flags.DEV_ATTACH_PAYMENT_SUMMARY */.id.DEV_ATTACH_PAYMENT_SUMMARY);
    var shouldShowCommentsInput = comments || isCommentsSectionOpen;
    var termsAndConditionsDisabled = requireTermsAndConditions && !termsAndConditionsAccepted || requirePrivacyPolicy && !privacyPolicyAccepted;
    var paymentMethodNotSelected = !hasMinimumPaymentMethodValue || (paymentMethodCurrentData === null || paymentMethodCurrentData === void 0 ? void 0 : paymentMethodCurrentData.isDisabled) || hasOrdersToBePaid;
    var isMainButtonDisabled = paymentMethodNotSelected || isPaymentScreen && termsAndConditionsDisabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOverlay, {
                    open: isCouponModalOpen,
                    blocking: false,
                    children: isCouponModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponModal/* CouponModal */.y, {
                        onClose: function() {
                            setIsCouponModalOpen(false);
                        },
                        orderId: orderId
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(checkout_tabs, {
                                    dataSource: tabs,
                                    router: router
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabContent, {
                                    children: getChildren((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                        ordersToBePaid: ordersToBePaid,
                                        paymentMethodCurrentData: paymentMethodCurrentData
                                    }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PricingContainer, {
                            requireTerms: requireTermsAndConditions,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PanelContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LineItemsSummary, {
                                            lineItems: currentOrder.lineItems
                                        }),
                                        hidePricing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                                            className: "p-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Los precios han sido previamente acordados."
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CartPricing, {
                                            lines: lines
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponCard, {
                                            couponsList: orderData === null || orderData === void 0 ? void 0 : (ref7 = orderData.order) === null || ref7 === void 0 ? void 0 : ref7.coupons,
                                            onOpen: function() {
                                                return setIsCouponModalOpen(true);
                                            },
                                            orderId: orderId,
                                            style: {
                                                order: isMobile ? 1 : null
                                            }
                                        }),
                                        hasOrderCommentsFF && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommentsContainer, {
                                            style: {
                                                order: isMobile ? 2 : null
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommentsLabelContainer, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                            className: "font-semibold",
                                                            children: "Comentario"
                                                        }),
                                                        !isCommentsSectionOpen && !comments && /*#__PURE__*/ (0,jsx_runtime.jsx)(action/* default */.Z, {
                                                            $color: "info",
                                                            onClick: function() {
                                                                setIsCommentsSectionOpen(true);
                                                            },
                                                            children: "Agregar"
                                                        })
                                                    ]
                                                }),
                                                shouldShowCommentsInput && /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentsInputContainer, {
                                                    $isInsideCard: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextareaWithCounter */.Y2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commentsField.input), {
                                                        maxLength: 200
                                                    }))
                                                })
                                            ]
                                        }),
                                        isPaymentScreen && (requireTermsAndConditions || requirePrivacyPolicy) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditionsSection, {
                                            style: {
                                                flexDirection: "column",
                                                order: 5
                                            },
                                            paymentMethodSlug: paymentMethodSlug,
                                            vendor: vendor,
                                            requireTermsAndConditions: requireTermsAndConditions,
                                            requirePrivacyPolicy: requirePrivacyPolicy
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(checkout_navigator, {
                                    mainButtonLabel: getNavigatorLabel(),
                                    isMainButtonDisabled: isMainButtonDisabled,
                                    isMainButtonLoading: submittingMainButton || processing || blockOrderByStatus,
                                    onClickMainButton: onClickMainButton,
                                    showCartPricing: !hidePricing && attachPaymentSummary,
                                    isCartPricingOpen: isCartPricingOpen,
                                    onCloseCartPricing: onCloseCartPricing
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(checkout_navigator, {
                    mainButtonLabel: getNavigatorLabel(),
                    isMainButtonDisabled: isMainButtonDisabled,
                    isMainButtonLoading: submittingMainButton || processing || blockOrderByStatus,
                    onClickMainButton: onClickMainButton,
                    showCartPricing: !hidePricing && attachPaymentSummary,
                    isCartPricingOpen: isCartPricingOpen,
                    onCloseCartPricing: onCloseCartPricing,
                    priceLines: lines
                })
            ]
        })
    });
};
/* harmony default export */ var content = ((0,next_router.withRouter)(CheckoutContent));

// EXTERNAL MODULE: ./src/utils/is-valid-time-range.ts
var is_valid_time_range = __webpack_require__(77105);
;// CONCATENATED MODULE: ./src/layouts/checkout/get-initial-values.js






var dataPaths = {
    deliveryAddressId: "deliveryAddress.id",
    storeId: "store.id",
    documentId: "document.id",
    deliveryTimeRangeId: "deliveryTimeRange.id",
    documentTypeSlug: "document.documentType.slug",
    shippingTypeId: "shippingType.id"
};
/**
 * Gets some ids and slugs from an order instance to preload the checkout state,
 * i.e. The FinalForm state inside the checkout.
 * Note that it can receive the user's last order, so it can't preload values
 * like dedicationMessage or deliveryDate.
 *
 * @param {Order} order Could be the last order or the current one
 * @returns {object} A clean checkout state, without null or undefined values
 */ var getCleanAssociations = function(order) {
    var getValue = function(dataPath) {
        return (0,lodash.get)(order, dataPath);
    };
    var checkoutState = (0,lodash.mapValues)(dataPaths, getValue);
    return (0,lodash.omitBy)(checkoutState, lodash.isNil);
};
/**
 * Gets some current checkout values to re-set the final form state
 *
 * @param {Order} currentOrder The current order which is processing
 * @param {object} checkoutConfig Contains the default delivery date
 * @returns {object}
 */ var getCheckoutValues = function(currentOrder, checkoutConfig) {
    var checkoutValues = {
        dedicationMessage: currentOrder.dedicationMessage,
        hasDedicationMessage: !(0,lodash.isNil)(currentOrder.dedicationMessage),
        deliveryDate: currentOrder.deliveryDate,
        purchaseOrderUrl: currentOrder.purchaseOrderUrl,
        needsPurchaseOrder: currentOrder.needsPurchaseOrder
    };
    var paymentMethod = currentOrder.paymentMethod;
    if (paymentMethod) {
        var isValid = (0,lodash.some)(checkoutConfig.paymentMethods, {
            id: paymentMethod.id
        });
        if (isValid) {
            checkoutValues.paymentMethodId = paymentMethod.id;
            checkoutValues.paymentMethodSlug = paymentMethod.slug;
        }
    }
    return checkoutValues;
};
/**
 * Check if the initial values has a valid document type
 *
 * @param {object} initialValues May contain the initial document type
 * @param {object} checkoutConfig Contains the vendor's document types
 */ var hasValidDocumentType = function(initialValues, checkoutConfig) {
    var documentTypes = checkoutConfig.documentTypes;
    var documentTypeSlug = initialValues.documentTypeSlug;
    return (0,lodash.some)(documentTypes, {
        slug: documentTypeSlug
    });
};
/**
 * Check if the initial values has a valid shipping type
 *
 * @param {object} initialValues May contain the initial shipping type
 * @param {object} checkoutConfig Contains the vendor's shipping types
 */ var hasValidShippingType = function(initialValues, checkoutConfig) {
    var shippingTypes = checkoutConfig.shippingTypes;
    var shippingTypeId = initialValues.shippingTypeId;
    return (0,lodash.some)(shippingTypes, {
        id: shippingTypeId
    });
};
/**
 * Check if the initial values has a valid delivery time range
 *
 * @param {object} initialValues May contain the initial delivery time range
 * @param {object} checkoutConfig Contains the vendor's delivery time ranges
 */ var hasValidDeliveryTimeRange = function(initialValues, checkoutConfig) {
    var ref, ref1;
    var deliveryTimeRanges = checkoutConfig.deliveryTimeRanges;
    var deliveryTimeRangeId = initialValues.deliveryTimeRangeId, deliveryDate = initialValues.deliveryDate;
    var query = {
        id: deliveryTimeRangeId
    };
    var deliveryTimeRange = (0,lodash.find)(deliveryTimeRanges, query);
    if (!deliveryTimeRange) {
        return false;
    }
    var preferCheckMinHour = checkoutConfig === null || checkoutConfig === void 0 ? void 0 : (ref = checkoutConfig.settings) === null || ref === void 0 ? void 0 : (ref1 = ref.deliveryTimeRange) === null || ref1 === void 0 ? void 0 : ref1.preferCheckMinHour;
    var validationOptions = {
        deliveryDate: deliveryDate,
        preferCheckMinHour: preferCheckMinHour,
        timeRange: deliveryTimeRange.time
    };
    return (0,is_valid_time_range/* default */.Z)(validationOptions);
};
var validateValues = function(baseValues, config) {
    var values = (0,_object_spread/* default */.Z)({}, baseValues);
    var deliveryTimeRanges = config.deliveryTimeRanges, _documentTypes = (0,_sliced_to_array/* default */.Z)(config.documentTypes, 1), firstDocumentType = _documentTypes[0], _shippingTypes = (0,_sliced_to_array/* default */.Z)(config.shippingTypes, 1), firstShippingType = _shippingTypes[0];
    if (!hasValidDocumentType(values, config)) {
        values.documentTypeSlug = firstDocumentType.slug;
    }
    if (!hasValidShippingType(values, config)) {
        values.shippingTypeId = firstShippingType.id;
    }
    var query = {
        id: values.shippingTypeId
    };
    var shippingTypeSlug = (0,lodash.find)(config.shippingTypes, query).slug;
    var isPickup = shippingTypeSlug === constants/* shippingTypes.PICKUP_IN_STORE */.zo.PICKUP_IN_STORE;
    if (isPickup) {
        values.deliveryAddressId = null;
        if (config.buyingInStore) {
            values.storeId = config.buyingInStore.id;
        }
    } else {
        values.storeId = null;
    }
    if (!deliveryTimeRanges) {
        return values;
    }
    var _deliveryTimeRanges = (0,_sliced_to_array/* default */.Z)(deliveryTimeRanges, 1), firstDeliveryTimeRange = _deliveryTimeRanges[0];
    if (deliveryTimeRanges.length === 1) {
        values.deliveryTimeRangeId = firstDeliveryTimeRange.id;
    }
    if (!hasValidDeliveryTimeRange(values, config)) {
        delete values.deliveryTimeRangeId;
    }
    return values;
};
/**
 * Check if store properties should filter shippingTypes
 *
 * @param {object} checkoutConfig Contains the vendor's shipping types
 * @param {object} isExclusiveDelivery If the current store has makesDelivery = true
 */ var getShippingTypes = function(checkoutConfig, isExclusiveDelivery) {
    var query = [
        "slug",
        constants/* shippingTypes.DELIVERY */.zo.DELIVERY
    ];
    if (isExclusiveDelivery) {
        return [
            (0,lodash.find)(checkoutConfig.shippingTypes, query)
        ];
    }
    return (0,lodash.reject)(checkoutConfig.shippingTypes, query);
};
var getPaymentMethods = function(checkoutConfig) {
    var paymentMethods = checkoutConfig.paymentMethods;
    if (checkoutConfig.settings) {
        var paymentMethodsSlugs = checkoutConfig.settings.deliveryPaymentMethods;
        if (Array.isArray(paymentMethodsSlugs)) {
            var getDeliveryPaymentMethods = function(paymentMethod) {
                return paymentMethodsSlugs.includes(paymentMethod.slug);
            };
            paymentMethods = (0,lodash.filter)(checkoutConfig.paymentMethods, getDeliveryPaymentMethods);
        }
    }
    return paymentMethods;
};
/**
 * Gets the initial values of checkout's final form instance. It takes care of
 * the last order to re-set the last used values in the checkout process
 */ var getInitialValues = function(config) {
    var checkoutData = config.checkoutData, buyingInStore = config.buyingInStore, stores = config.stores, multiDistributorSession = config.multiDistributorSession, expressDeliverySession = config.expressDeliverySession, comments = config.comments;
    var checkoutConfig = checkoutData.checkoutConfig, _checkoutState = checkoutData.checkoutState, lastOrder = _checkoutState.lastOrder, currentOrder = _checkoutState.currentOrder, addresses = _checkoutState.addresses;
    var hasStoreExclusiveDelivery = (0,lodash.some)(stores, "makesDelivery");
    var isExclusiveDelivery = buyingInStore === null || buyingInStore === void 0 ? void 0 : buyingInStore.makesDelivery;
    if (hasStoreExclusiveDelivery && !multiDistributorSession && !expressDeliverySession) {
        checkoutConfig.shippingTypes = getShippingTypes(checkoutConfig, isExclusiveDelivery);
    }
    if (isExclusiveDelivery) {
        checkoutConfig.paymentMethods = getPaymentMethods(checkoutConfig);
    }
    var lastOrderAssociations = getCleanAssociations(lastOrder);
    var currentAssociations = getCleanAssociations(currentOrder);
    var currentCheckoutValues = getCheckoutValues(currentOrder, checkoutConfig);
    var baseValues = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, lastOrderAssociations, currentAssociations, currentCheckoutValues), {
        comments: comments
    });
    var initialValues = validateValues(baseValues, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, checkoutConfig), {
        addresses: addresses,
        buyingInStore: buyingInStore
    }));
    if (multiDistributorSession) {
        var shippingType = (0,lodash.find)(checkoutConfig.shippingTypes, {
            isDelivery: multiDistributorSession.shippingType.isDelivery,
            isPickup: multiDistributorSession.shippingType.isPickup
        });
        initialValues.shippingTypeId = shippingType.id;
        var deliveryAddress = multiDistributorSession.deliveryAddress, storeId = multiDistributorSession.storeId;
        if (deliveryAddress) {
            initialValues.deliveryAddressId = deliveryAddress.id;
        } else if (storeId) {
            initialValues.storeId = storeId;
        }
    }
    if (expressDeliverySession) {
        initialValues.shippingTypeId = expressDeliverySession.shippingType.id;
        checkoutConfig.stores = stores;
        var deliveryAddress1 = expressDeliverySession.deliveryAddress, storeId1 = expressDeliverySession.storeId;
        if (deliveryAddress1) {
            initialValues.deliveryAddressId = deliveryAddress1.id;
        } else if (storeId1) {
            initialValues.storeId = storeId1;
        }
    }
    return initialValues;
};
/* harmony default export */ var get_initial_values = (getInitialValues);

;// CONCATENATED MODULE: ./src/layouts/checkout/index.js



















var CheckoutLayout = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var children = props.children, processing = props.processing, onSubmit = props.onSubmit, onValidate = props.onValidate;
    var buyingInStore = (0,use_buying_in_store/* default */.Z)();
    var multiDistributorSession = (0,use_multi_distributor_session/* default */.Z)().multiDistributorSession;
    var expressDeliverySession = (0,use_express_delivery_session/* default */.Z)().expressDeliverySession;
    var router = (0,next_router.useRouter)();
    var storesResponse = (0,react_hooks_esm/* useQuery */.aM)(queries/* storesQuery */.lw, {
        variables: {
            showAll: false
        }
    });
    var checkoutData = (0,react.useContext)(contexts/* CheckoutContext */.mN);
    var currentOrder = checkoutData.checkoutState.currentOrder;
    var ref5 = (0,react_hooks_esm/* useQuery */.aM)(queries/* commentsQuery */.r9, {
        fetchPolicy: "cache-only"
    }), commentsData = ref5.data;
    var ref6;
    var comments = (ref6 = commentsData === null || commentsData === void 0 ? void 0 : (ref = commentsData.user) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.comments) !== null && ref6 !== void 0 ? ref6 : currentOrder.comments;
    var openModal = (0,use_modal_manager/* default */.Z)().openModal;
    var hasShippingBeforeBuyFF = (0,toggled_esm/* useFlag */.P5)(constants/* flags.SHIPPING_BEFORE_BUY */.id.SHIPPING_BEFORE_BUY);
    var hasExpressDeliveryFF = (0,toggled_esm/* useFlag */.P5)(constants/* flags.EXPRESS_DELIVERY */.id.EXPRESS_DELIVERY);
    var sessionNotFound = hasExpressDeliveryFF && !expressDeliverySession || !hasExpressDeliveryFF && !multiDistributorSession;
    var suggestedProductsModalFF = (0,toggled_esm/* useFlag */.P5)(constants/* flags.SUGGESTED_PRODUCTS_MODAL */.id.SUGGESTED_PRODUCTS_MODAL);
    (0,react.useEffect)(function() {
        var ref;
        var deliveryAddress = (ref = expressDeliverySession === null || expressDeliverySession === void 0 ? void 0 : expressDeliverySession.deliveryAddress) !== null && ref !== void 0 ? ref : multiDistributorSession === null || multiDistributorSession === void 0 ? void 0 : multiDistributorSession.deliveryAddress;
        var ref1;
        var store = (ref1 = expressDeliverySession === null || expressDeliverySession === void 0 ? void 0 : expressDeliverySession.store) !== null && ref1 !== void 0 ? ref1 : multiDistributorSession === null || multiDistributorSession === void 0 ? void 0 : multiDistributorSession.store;
        if (suggestedProductsModalFF) {
            sessionStorage.removeItem(constants/* sessionStorageKeys.SUGGESTED_PRODUCT_MODAL_DISABLE */.Lc.SUGGESTED_PRODUCT_MODAL_DISABLE);
        }
        if (hasShippingBeforeBuyFF && (sessionNotFound || !deliveryAddress && !store)) {
            notifier/* default.error */.Z.error("Necesitas escoger un m\xe9todo de env\xedo y direcci\xf3n antes de procesar la compra.");
            openModal(shipping_modal/* default */.Z);
            router.replace("/");
        }
    }, [
        expressDeliverySession,
        hasShippingBeforeBuyFF
    ]);
    if (storesResponse.loading) {
        return null;
    }
    var stores = (ref2 = storesResponse.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.vendor) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.stores) === null || ref4 === void 0 ? void 0 : ref4.items;
    var initialValues = get_initial_values({
        checkoutData: checkoutData,
        buyingInStore: buyingInStore,
        stores: stores,
        multiDistributorSession: multiDistributorSession,
        expressDeliverySession: expressDeliverySession,
        comments: comments
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
        initialValues: initialValues,
        onSubmit: onSubmit,
        validate: onValidate,
        children: function(formProps) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_scroll_to_error/* FormScrollToError */.F, {
                        addHeaderOffset: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(content, {
                        processing: processing,
                        checkoutData: checkoutData,
                        formProps: formProps,
                        orderId: currentOrder.id,
                        children: children
                    })
                ]
            });
        }
    });
};
CheckoutLayout.Header = header;
/* harmony default export */ var checkout = (CheckoutLayout);


/***/ }),

/***/ 6361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* reexport */ use_theme; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/truck/hooks/use-theme.ts


// TODO: remove when styled-components has an official support for Hooks
// https://github.com/styled-components/styled-components/issues/2340
var useTheme = function() {
    return (0,react.useContext)(styled_components_browser_esm/* ThemeContext */.Ni);
};
/* harmony default export */ var use_theme = (useTheme);

;// CONCATENATED MODULE: ./src/truck/hooks/index.ts



/***/ }),

/***/ 88497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* reexport */ IconButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/truck/icon/index.tsx + 1 modules
var icon = __webpack_require__(63216);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/truck/icon-button/elements.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  width: fit-content;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  * {\n    :hover {\n      filter: brightness(0.89);\n    }\n\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var IconButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b6992a5b-0"
})(_templateObject(), function(props) {
    return props.disabled && "\n    cursor: not-allowed;\n  ";
}, function(props) {
    return props.size === "sm" && "\n    padding: ".concat(props.theme.spacing.compact, "px;\n  ");
}, function(props) {
    return props.size === "md" && "\n    padding: ".concat(props.theme.spacing.cozy, "px;\n  ");
}, function(props) {
    return props.disabled && "\n        fill: ".concat(props.theme.palette.grayscale60, ";\n        :hover {\n          filter: none;\n        }\n        cursor: inherit;\n      ");
});

;// CONCATENATED MODULE: ./src/truck/icon-button/icon-button.tsx





function IconButton(props) {
    var size = props.size, disabled = props.disabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButtonContainer, {
        size: size,
        disabled: disabled,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, (0,_object_spread/* default */.Z)({}, props))
    });
}

;// CONCATENATED MODULE: ./src/truck/icon-button/index.tsx



/***/ })

}]);